import Address1UnitNoZipCodeUtils from '../common/Address1UnitNoZipCodeUtils';
import IAddress1UnitNoZipCode from '../common/IAddress1UnitNoZipCode';
import IComp from '../Comp';
import CompAddressUtils from './CompAddressUtils';
import IComps from './IComps';

export default {
    getByAddress1UnitNoAndZipCode(comps: IComps, criteria: IAddress1UnitNoZipCode): IComp | null {
        for (const comp of comps) {
            const address1UnitNoZipCode = CompAddressUtils.getAddress1UnitNoAndZipCode(comp.address);
            const matches = Address1UnitNoZipCodeUtils.matches(address1UnitNoZipCode, criteria);
            if (matches) {
                return comp;
            }
        }
        return null;
    }
};
